import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import apiService from 'app/bff/services/apiService';
import { InsuranceSidEnum } from 'app/bff/enums/insurance';
import { PolicyStatusTextEnum } from 'app/bff/enums/policy';
import { PolicyPolistResp } from 'app/bff/models/policy/policyPolist';
import { ROUTES } from 'app/core/router/paths';
import commonService from 'app/core/services/commonService';
import storageService from 'app/core/services/storageService';
import { StorageKeysEnum } from 'app/core/enums/storage';
import { RootState } from 'app/store/types';

const Reminder: React.FC = () => {
  const routerLocation = useLocation();
  const memberState = useSelector((state: RootState) => state.common.member);
  const authorizationState = memberState.authorization;
  const memberProfileState = memberState.profile;
  const [visible, setVisible] = useState<boolean>(false);
  const [dataSourceState, setDataSourceState] = useState<PolicyPolistResp['policyTravel']>([]);

  /**
   * @description 取得尚未繳費保單資料
   */
  useEffect(() => {
    if (
      JSON.parse(storageService.getItem(StorageKeysEnum.ApplyReminder)) !== false && // 此緩存若為 false 代表透過使用者透過關閉按鈕進行關閉
      !routerLocation.pathname.includes(ROUTES.SERVICE__QUERY_POLICY) &&
      !routerLocation.pathname.includes(ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE) &&
      memberProfileState
    ) {
      (async () => {
        const response = await apiService.postPolicyPolist({ insuranceSid: InsuranceSidEnum.Travel, userId: memberProfileState.USERS.ROC_ID });
        if (response) {
          const unpaidData = response.filter((data) => data.policyStatus === PolicyStatusTextEnum.Unpaid && moment().unix() < moment(data.paymentDeadline).unix());
          if (unpaidData.length > 0) {
            setDataSourceState(unpaidData);
            setVisible(true);
          }
        }
      })();
    } else {
      setVisible(false);
    }
  }, [memberProfileState, routerLocation.pathname]);

  /**
   * @description 會員登出則清除 Storage 緩存
   */
  useEffect(() => {
    if (!authorizationState) storageService.removeItem(StorageKeysEnum.ApplyReminder);
  }, [authorizationState]);

  /**
   * @description 處理關閉
   */
  const handleClose = () => {
    setVisible(false);
    storageService.setItem(StorageKeysEnum.ApplyReminder, JSON.stringify(false));
  };

  return visible
    ? (
      <div className="reminder">
        <div className="for-desktop">
          <div className="head">
            <img src={require('assets/img/pic/bear-reminder.svg').default} className="avatar" alt="" />
            <div className="ms-2">熊保悄悄話</div>
            <img src={require('assets/img/icons/black-cross.svg').default} className="cross" alt="" onClick={handleClose} />
          </div>
          <div className="subject">哈囉，您還有 {dataSourceState.length} 張保單尚未繳費哦！</div>
          {dataSourceState.map((source) => (
            <div className="text" key={source.policyNo}>
              {source.productName} &nbsp; &nbsp; 繳費截止日 &nbsp; {commonService.convertToTWDate(source.paymentDeadline)} {moment(source.paymentDeadline).format('HH:mm:ss')}
            </div>
          ))}
          <div className="d-flex justify-content-center">
            <Link to={ROUTES.SERVICE__QUERY_POLICY__LIST} className="btn-wrapper">
              <button title="前往「保單查詢頁」" type="button" className="btn btn-primary">前往繳費</button>
            </Link>
          </div>
        </div>
        <div className="for-mobile">
          <div className="dialogue">
            <div className="subject">哈囉，您還有 {dataSourceState.length} 張保單尚未繳費哦！</div>
            <Link to={ROUTES.SERVICE__QUERY_POLICY__LIST}>
              <div title="前往「保單查詢頁」">前往繳費</div>
            </Link>
          </div>
          <div className="avatar-wrapper">
            <img src={require('assets/img/pic/bear-reminder.svg').default} className="avatar" alt="" />
          </div>
        </div>
      </div>
      )
    : null;
};

Reminder.defaultProps = {
  visible: false
};

export default Reminder;
